export default "__VITE_ASSET__39ClJ_IC__"